export const VIEW_TYPE = {
  CALENDAR: 'calendar',
  LIST: 'list',
  MAP: 'map',
};

export const MAP_VIEW_SETTINGS = {
  ALWAYS_SHOWN: 'always_shown',
  ALWAYS_HIDDEN: 'always_hidden',
  USER_DEFINED: 'user_defined',
};
